import "./scratchpads-exec.less";

import Backbone from "backbone";
import Handlebars from "handlebars";
// eslint-disable-next-line no-restricted-imports -- we need to import jquery for live-editor
import $ from "jquery";
import esprima from "live-editor/build/external/structuredjs/external/esprima";
import _ from "underscore";

import {loadLiveEditorI18n} from "@khan/component-live-editor";
import {importFromExternalScript} from "@khan/util-external-script";

export const init = async (hostname: string) => {
    // NOTE(jeresig): We need to make these globals so that LiveEditor knows how
    // to access them. Should go away once it's rewritten to use React.
    // @ts-expect-error - TS2339 - Property 'i18n' does not exist on type 'Window & typeof globalThis'.
    window.i18n = loadLiveEditorI18n();
    window.Backbone = Backbone;
    window.Handlebars = Handlebars;
    // @ts-expect-error - TS2322 - Type 'UnderscoreStatic' is not assignable to type 'LoDashStatic'.
    window._ = _;
    // @ts-expect-error - Property '$' does not exist on type 'Window & typeof globalThis'.ts(2339)
    window.$ = $;
    // @ts-expect-error - TS2339 - Property 'esprima' does not exist on type 'Window & typeof globalThis'.
    window.esprima = esprima;

    await import("live-editor/build/js/live-editor.shared");
    // Defines OutputTester as a global which is needed by the next two modules.
    const {LiveEditorOutput} = await import(
        "live-editor/build/js/live-editor.output"
    );
    // We load this as a static JS file to avoid having to build them using
    // Webpack, as it's quite large (~1.72MB in total). As a result we're not
    // going to be able to update this file in a traditional manner. We'll have
    // to either rename it or clear the cache in Fastly if we ever change it.
    // Also this file will never be able to have i18n strings inside it.
    await importFromExternalScript(
        // We explicitly want to load this from the CDN always.
        // eslint-disable-next-line static-service/dont-hardcode-cdn -- see above
        "https://cdn.kastatic.org/third_party/javascript-khansrc/live-editor/build/js/live-editor.output_pjs_deps.js",
    );
    await import("live-editor/build/js/live-editor.output_pjs");

    /**
     * Our worker scripts may be loaded from a different domain (such as the
     * Fastly CDN). Workers are not allowed to load scripts across
     * origin, however (and this seems silly) workers are allowed to use
     * importScripts to load a script across origins. So we replace the getURL
     * method of PooledWorker to load the worker in a dynamically-generated
     * worker that uses importScripts. More information on this technique:
     * https://medium.com/@krishnachirumamilla/content-security-policy-worker-src-cd06ecfa2fe8
     */
    // @ts-expect-error - TS2339 - Property 'PooledWorker' does not exist on type 'Window & typeof globalThis'.
    const oldGetURL = window.PooledWorker.prototype.getURL;

    // @ts-expect-error - TS2339 - Property 'PooledWorker' does not exist on type 'Window & typeof globalThis'.
    window.PooledWorker.prototype.getURL = function (this: any) {
        const workerURL = oldGetURL.call(this);
        const blob = new Blob([`importScripts('${workerURL}');`], {
            type: "application/javascript",
        });
        return URL.createObjectURL(blob);
    };

    /* Initialize LiveEditorOutput.
    We do it here to make sure everything has been loaded already. */
    /*
     * To prevent XSS, we don't want people embedding
     * http://www.khanacademy.org/computer-programming/exec directly because it's
     * happy to run arbitrary JS sent via postMessage
     * TODO(alpert): Protect nondefault instances too
     */
    if (!/\bkhanacademy\.org$/i.test(hostname)) {
        // Hook in the execution enviroment
        // eslint-disable-next-line no-new -- this is part of live-editor
        new LiveEditorOutput({
            el: $("#live-editor-output")[0],
        });
    }
};
